export const STORAGE_DELETE_CALL = 'storage_delete';
export const STORAGE_LIST_CALL = 'storage_list';
export const STORAGE_STATUS_CALL = 'storage_status';
export const MIN_RETRY_LIMIT = 1;
export const STORAGE_STATUS_RETRY = {
    BUDGET_MS: 30000,
    MIN_DELAY_MS: 1500,
    MAX_DELAY_MS: 4000,
};
export const MULTIMEDIA_TYPE = 'multimedia';
export const MEDIA_BUCKET_NAME = 'media';
export const STORAGE_RELATED_PREVIEW_TYPE = 'preview';
export const QUERY_PARAMS = {
    REDIRECT_SUPPORT: 'redirect_support',
    UUID: 'uuid',
    KEY: 'key',
};
export const REDIRECT_SUPPORT_VALUE = 1;
export const SUCCESS_API_STATUS_CODE = 200;
export const SUCCESS_API_STATUS = 1;
export const FILE = 'file';
